import { HomeContent } from '~/features/home/HomeContent'
export default HomeContent
